export default __webpack_public_path__ + "static/media/pwp.750ed433.JPG";